import { UserRole } from '@sharefiledev/permissions-pilet';
import { EventMetadata } from '../model/types';
import { logger } from '../utils/logger';

interface Window {
	pendo?: any;
}

export const pendoSendTrackEvent = (event: string, metadata: EventMetadata = {}) => {
	try {
		const pendo = (window as unknown as Window).pendo;
		if (!pendo?.track) {
			return;
		}
		// Only add timestamp if metadata is provided
		const _metadata =
			metadata && Object.keys(metadata).length > 0
				? {
						...metadata,
						userType: metadata.userType || UserRole.Employee,
				  }
				: {};

		const metadataWithProductName = {
			..._metadata,
			product: 'ShareFile - DataTable',
			type: event,
		};
		pendo.track(event, metadataWithProductName);
	} catch (error) {
		logger.logError('error occred while raising pendo event');
	}
};
